/* eslint-disable @angular-eslint/directive-selector */

import { Directive, input } from '@angular/core';
import { AbstractControl, NG_ASYNC_VALIDATORS, ValidationErrors, Validator } from '@angular/forms';
import { CustomValidationService } from '../services/custom-validation.service';

export type UniqueValidatorFn = (value: string) => Promise<boolean>;

@Directive({
  selector: '[unique]',
  providers: [{
    provide: NG_ASYNC_VALIDATORS, useExisting: UniqueValidatorDirective, multi: true
  }]
})
export class UniqueValidatorDirective implements Validator {
  unique = input.required<UniqueValidatorFn>();

  validate(control: AbstractControl<any, any>): ValidationErrors {
    return CustomValidationService.uniqueValidator(this.unique())(control);
  }
}
